import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';

const team = [
  {
    name: 'John Smith',
    role: 'CEO & Founder',
    image: 'https://source.unsplash.com/random/400x400/?portrait,man',
    bio: 'With over 15 years of experience in restaurant technology, John leads our vision and strategy.',
  },
  {
    name: 'Sarah Johnson',
    role: 'Head of Product',
    image: 'https://source.unsplash.com/random/400x400/?portrait,woman',
    bio: 'Sarah brings 10+ years of product management experience to create the best POS solution.',
  },
  {
    name: 'Michael Chen',
    role: 'CTO',
    image: 'https://source.unsplash.com/random/400x400/?portrait,asian',
    bio: 'Michael leads our technical innovation and ensures we stay ahead of industry trends.',
  },
  {
    name: 'Emily Davis',
    role: 'Head of Customer Success',
    image: 'https://source.unsplash.com/random/400x400/?portrait,woman',
    bio: 'Emily ensures our customers get the most value from our platform.',
  },
];

const values = [
  {
    icon: <RestaurantIcon sx={{ fontSize: 40, color: '#234734' }} />,
    title: 'Restaurant-First',
    description: 'We understand the unique challenges of running a restaurant and build solutions that address them.',
  },
  {
    icon: <EmojiEventsIcon sx={{ fontSize: 40, color: '#234734' }} />,
    title: 'Excellence',
    description: 'We strive for excellence in everything we do, from product development to customer support.',
  },
  {
    icon: <GroupIcon sx={{ fontSize: 40, color: '#234734' }} />,
    title: 'Collaboration',
    description: 'We believe in the power of teamwork and collaboration to achieve great results.',
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 40, color: '#234734' }} />,
    title: 'Trust',
    description: 'We build trust through transparency, security, and reliable service.',
  },
];

function About() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: { xs: 6, md: 8 },
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h1"
            align="center"
            sx={{
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 700,
              mb: 2,
            }}
          >
            About Restro360
          </Typography>
          <Typography
            variant="h5"
            align="center"
            sx={{ opacity: 0.9 }}
          >
            Empowering restaurants with smart technology
          </Typography>
        </Container>
      </Box>

      {/* Mission Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" gutterBottom>
              Our Mission
            </Typography>
            <Typography variant="body1" paragraph>
              At Restro360, we're on a mission to revolutionize the restaurant industry
              through innovative technology. We believe that every restaurant,
              regardless of size, deserves access to tools that can help them
              succeed in today's competitive market.
            </Typography>
            <Typography variant="body1" paragraph>
              Our comprehensive POS solution combines powerful features with
              intuitive design, making it easier for restaurant owners to manage
              their operations, delight their customers, and grow their business.
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Simplify restaurant operations"
                  secondary="Streamline your workflow with our all-in-one solution"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Enhance customer experience"
                  secondary="Deliver exceptional service with our customer-focused features"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CheckCircleIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Drive business growth"
                  secondary="Make data-driven decisions to increase profitability"
                />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Container>

      {/* Values Section (no cards) */}
      <Box sx={{ bgcolor: 'grey.50', py: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            align="center"
            gutterBottom
          >
            Our Values
          </Typography>
          <Grid container spacing={4} sx={{ mt: 2 }} justifyContent="center">
            {values.map((value, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box sx={{ textAlign: 'center', p: 2 }}>
                  <Box sx={{ mb: 2 }}>{value.icon}</Box>
                  <Typography variant="h5" gutterBottom sx={{ color: '#234734', fontWeight: 700 }}>
                    {value.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {value.description}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

    </Box>
  );
}

export default About; 